import { render } from "./TranReduce.vue?vue&type=template&id=7a7cac38&ts=true"
import script from "./TranReduce.vue?vue&type=script&lang=ts"
export * from "./TranReduce.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__